import React from 'react'
import { useSearch } from '@tanstack/react-router'

export const useRecruitmentSearch = () => {
    const searchValues = useSearch({
        from: '/_dashboard/recruitment/',
        select: (search) => {
            return {
                phone: search.phone,
                from_date: search.from_date,
                to_date: search.to_date,
                recruiter_id: search.recruiter_id,
                page: search.page,
            }
        },
    })

    const isSearch = React.useMemo(
        () =>
            Boolean(
                searchValues.phone ||
                    searchValues.from_date ||
                    searchValues.to_date ||
                    searchValues.recruiter_id
            ),
        [searchValues]
    )

    return { isSearch, searchValues }
}
